module.exports = __webpack_public_path__ + "assets/tree-table.b75e9e59.svg";